<div class="col">

  <button class="btn-link  text-uppercase float-end close" (click)="closeWindow()">
                  &times;
                </button>
</div>
<h4 class="text-center"> Enter your Password
</h4>
<form *ngIf="confirmPasswordFG" class="form user-form p-v" #form="ngForm" [formGroup]="confirmPasswordFG" (ngSubmit)="confirmPassword(form)"
  novalidate>


  <div class="row">
    <div class="col"></div>
    <div class="col-8">
      <div [hidden]="!submitError" class="alert alert-danger">
        {{submitError}}
      </div>
      <div class="input-group">

        <input formControlName="password" type="password" class="input frm-input">

        <button [loading]="sendingPasswordInProgress" type="submit" class="">Confirm Password</button>
      </div>
      <div [hidden]="confirmPasswordFG.controls['password'].valid || !form.submitted" class="alert alert-danger">
        <span [hidden]="!confirmPasswordFG.controls.password.errors?.required">password is required</span>
        <span [hidden]="!confirmPasswordFG.controls.password.errors?.password">password is invalid</span>
      </div>
    </div>
    <div class="col"></div>
  </div>
</form>
